
import { prototype } from 'module';
<template>
  <div>
    <div v-html='type'>{{type}}</div>
    <div class='clpp-api-indent clpp-api-description' v-html="description" v-if='description'>{{description}}</div>
  </div>
</template>

<script>
import { DocsComponentMixin } from '../../utils/docs';

export default {
  // extends: DocsComponent,
  mixins: [DocsComponentMixin],

  name: 'DocsDetailThrows'
};
</script>
